import React from "react";
import "../style/ServicesPage.css";

import hero from "../../assets/herosection-for-service.png";
import air from "../../assets/Air-way.png";
import road from "../../assets/road-way.png";
import sea from "../../assets/water-way.png";
import warehouse from "../../assets/wearhouse.png";
import customs from "../../assets/customs.png";
import courier from "../../assets/courier.png";

const services = [
  {
    title: "Customs Clearance Services",
    image: customs,
    desc: "Reliable and hassle-free customs clearance for import and export shipments, including documentation, duty consultation, and port & airport clearance.",
  },
  {
    title: "Freight Forwarding",
    image: air,
    desc: "Smooth cargo movement across borders using air, sea, and land transport with door-to-door delivery and heavy cargo handling.",
  },
  {
    title: "Container Booking & Management",
    image: sea,
    desc: "Complete FCL and LCL container booking with tracking, monitoring, and stuffing & destuffing services.",
  },
  {
    title: "Domestic & International Transport",
    image: road,
    desc: "Nationwide and global transportation solutions for B2B and B2C commercial and industrial shipments.",
  },
  {
    title: "Courier & Express Services",
    image: courier,
    desc: "Fast commercial courier services with DHL, UPS, FedEx, and DPD for documents, parcels, and urgent deliveries.",
  },
  {
    title: "Commercial Shipment Solutions",
    image: warehouse,
    desc: "Specialized logistics including bulk shipments, e-commerce fulfillment, warehousing support, and reverse logistics.",
  },
];

const Services = () => {
  return (
    <div className="services-page">
      {/* Hero Section */}
      <div
        className="services-hero"
        style={{ backgroundImage: `url(${hero})` }}
      >
        <div className="hero-overlay">
          <h1>End-to-End Logistics Solutions</h1>
          <p>
            At PFA Logistics Pvt. Ltd, we provide complete logistics and supply
            chain solutions across India and worldwide with trusted global
            partners.
          </p>
        </div>
      </div>

      {/* Services Grid */}
      <h2 className="services-heading">Our Services</h2>

      <div className="services-container">
        {services.map((service, index) => (
          <div className="service-card" key={index}>
            <img src={service.image} alt={service.title} />
            <div className="service-content">
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
              <button>Learn More</button>
            </div>
          </div>
        ))}
      </div>

      {/* Why Choose Us */}
      <div className="why-choose">
        <h2>Why Choose PFA Logistics Pvt. Ltd?</h2>
        <div className="why-grid">
          <div>
            <h4>Global Network</h4>
            <p>Strong logistics network across major international routes.</p>
          </div>
          <div>
            <h4>End-to-End Solutions</h4>
            <p>From pickup to final delivery with complete transparency.</p>
          </div>
          <div>
            <h4>Real-Time Tracking</h4>
            <p>Track your shipments with live updates and reporting.</p>
          </div>
          <div>
            <h4>On-Time Delivery</h4>
            <p>Committed to secure, fast, and cost-effective delivery.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
